import * as React from 'react';
import { Grid, Typography } from '@material-ui/core';
import NewItemButton from '../../Button/NewItemButton';

export const NoEventComponent = (props: { events: number; classes: any; onNewEventClick: () => any; }) => {
    return <Grid container style={{ justifyContent: 'center' }}>
        <Grid item sm={12} style={{ padding: 5 }}>
            <Typography>{props.events} eventi nel periodo visualizzato</Typography>
        </Grid>
        <Grid item sm={12} style={{ padding: 5 }}>
            <Typography>Seleziona un evento per vedere e modificare i dettagli</Typography>
        </Grid>
        <Grid item sm={12} style={{ padding: 5 }}>
            <Typography>oppure</Typography>
        </Grid>
        <Grid item sm={12} className={props.classes.buttonsContainer}>
            <NewItemButton text='Crea un nuovo evento' onClick={props.onNewEventClick} />
        </Grid>
    </Grid>;
};
